import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureTypeSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/procedure-types/$procedureTypeId/"
					to="/$organizationId/settings/procedure-types"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Procedure types
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureTypeSettingsDetailViewTopBar.displayName = "ProcedureTypeSettingsDetailViewTopBar"
